export default __webpack_public_path__ + "static/media/2CBDBK5.7f594ff5.jpg";